<app-slide-in-right-modal
  modalTitle="Transfer"
  iconImageSrc="assets/images/svgs/transfer-arrow--duotone.svg"
  [slideOpen]="true"
>
  <div class="page__container flex flex-col pb-8">
    <p *ngIf="currentRMName" class="cta__text text-sm text-mango-gray74">
      Transfer accounts for <b>{{ currentRMName }}</b>
    </p>

    <form class="flex flex-col gap-5 px-0 pt-5" [formGroup]="transferForm">
      <div>
        <div class="flex items-center justify-between">
          <label for="new-rm" class="text-base font-bold leading-6 text-mango-gray700">
            New Relationship Manager
          </label>
          <span class="text-sm leading-6 text-gray-500">*required field</span>
        </div>
        <select
          id="new-rm"
          formControlName="new_rm_id"
          class="mt-2 block w-full cursor-pointer rounded-lg border-0 pl-2 text-base text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:leading-6"
        >
          <option value="" disabled>Select a relationship manager</option>
          @for (rm of otherRMs; track rm.id) {
            <option [value]="rm.id">{{ rm.first_name }} {{ rm.last_name }}</option>
          }
        </select>
      </div>

      <div>
        <div class="flex items-center justify-between">
          <span class="text-base font-bold leading-6 text-mango-gray700">Accounts to transfer</span>
          <span class="text-sm leading-6 text-gray-500">*required field</span>
        </div>

        <div class="mt-4 divide-y divide-gray-200 border-b border-t border-gray-200">
          <label class="relative flex items-center gap-3 py-4">
            <input
              type="radio"
              formControlName="scope"
              value="all"
              class="h-4 w-4 border-gray-300 text-mango focus:ring-mango"
            />
            <span class="select-none text-sm font-medium text-gray-900">Transfer All</span>
          </label>

          <label class="relative flex items-center gap-3 py-4">
            <input
              type="radio"
              formControlName="scope"
              value="category"
              class="h-4 w-4 border-gray-300 text-mango focus:ring-mango"
            />
            <span class="select-none text-sm font-medium text-gray-900">Transfer by Category</span>
          </label>

          @if (transferForm.value.scope === 'category') {
            <div class="pb-4 pl-7">
              <select
                formControlName="category"
                class="block w-full cursor-pointer rounded-lg border-0 pl-2 text-base text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:leading-6"
              >
                <option value="" disabled>Select a category</option>
                @for (category of categoryOptions; track category.key) {
                  <option [value]="category.key">{{ category.value }}</option>
                }
              </select>
            </div>
          }

          <label class="relative flex items-center gap-3 py-4">
            <input
              type="radio"
              formControlName="scope"
              value="selected"
              class="h-4 w-4 border-gray-300 text-mango focus:ring-mango"
            />
            <span class="select-none text-sm font-medium text-gray-900">Transfer Selected Accounts</span>
          </label>

          @if (transferForm.value.scope === 'selected') {
            <div class="pb-4">
              @if (isFetchingAccounts) {
                <p class="text-sm text-gray-500">Loading accounts...</p>
              } @else {
                <div class="mb-3 flex items-center gap-3">
                  <div class="relative w-1/2">
                    <img
                      class="absolute bottom-[13px] left-3.5"
                      src="assets/images/svgs/search.svg"
                      alt=""
                    />
                    <input
                      type="search"
                      [(ngModel)]="accountSearchQuery"
                      [ngModelOptions]="{ standalone: true }"
                      class="block w-full rounded-lg border-0 py-[0.62rem] pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-base placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango focus-visible:ring-mango sm:text-sm sm:leading-6"
                      placeholder="Search"
                    />
                  </div>
                  <select
                    base-select
                    [(ngModel)]="accountTypeFilter"
                    [ngModelOptions]="{ standalone: true }"
                    class="w-1/2"
                  >
                    <option value="">All Account Types</option>
                    @for (category of categoryOptions; track category.key) {
                      <option [value]="category.key">{{ category.value }}</option>
                    }
                  </select>
                </div>

                <div class="max-h-72 overflow-y-auto rounded-lg border border-solid border-mango-gray200">
                  <table class="min-w-full leading-normal">
                    <thead>
                      <tr>
                        <th class="border-b-2 border-gray-200 bg-gray-100 px-3 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"></th>
                        <th class="border-b-2 border-gray-200 bg-gray-100 px-3 py-3 text-left text-xs font-semibold tracking-wider text-gray-600">Account Name</th>
                        <th class="border-b-2 border-gray-200 bg-gray-100 px-3 py-3 text-left text-xs font-semibold tracking-wider text-gray-600">Account No.</th>
                        <th class="border-b-2 border-gray-200 bg-gray-100 px-3 py-3 text-left text-xs font-semibold tracking-wider text-gray-600">Account Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      @if (filteredAccounts.length === 0) {
                        <tr>
                          <td colspan="4" class="border-b border-gray-200 bg-white px-3 py-4 text-center text-sm text-gray-500">
                            No accounts found.
                          </td>
                        </tr>
                      } @else {
                        @for (account of filteredAccounts; track account.id) {
                          <tr>
                            <td class="border-b border-gray-200 bg-white px-3 py-3 text-sm">
                              <input
                                type="checkbox"
                                class="h-4 w-4 rounded border-gray-300 text-mango focus:ring-mango"
                                [checked]="isAccountSelected(account.id)"
                                (change)="toggleAccountSelection(account.id, $any($event.target).checked)"
                              />
                            </td>
                            <td class="border-b border-gray-200 bg-white px-3 py-3 text-sm text-gray-900">
                              {{ getAccountLabel(account) }}
                            </td>
                            <td class="border-b border-gray-200 bg-white px-3 py-3 text-sm text-gray-900">
                              {{ account.mango_account_number }}
                            </td>
                            <td class="border-b border-gray-200 bg-white px-3 py-3 text-sm text-gray-900">
                              {{ account.account_type | uppercase }}
                            </td>
                          </tr>
                        }
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
          }
        </div>
      </div>

      <div class="flex justify-end">
        <button
          (click)="submit()"
          class="cursor-pointer justify-center"
          mango-button
          [disabled]="!isFormValid || isSubmitting"
          [loading]="isSubmitting"
        >
          <span *ngIf="isSubmitting" spin></span>
          {{ isSubmitting ? 'Transferring...' : 'Transfer' }}
        </button>
      </div>
    </form>
  </div>
</app-slide-in-right-modal>
